/**
 * EC Visitor ID Capture v2 — Shopify Theme Script
 *
 * Reads ec_vid and ec_var from URL params (set by landing page CTA),
 * persists to localStorage, and attaches to Shopify cart + checkout forms.
 *
 * v2: Added MutationObserver + form.submit() intercept to survive
 * cart/clear operations on bundle builder pages (ec71-bundle, ec93).
 *
 * Add to theme via: {% render 'ec-vid-capture' %}
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'ec_vid';
  var VARIANT_KEY = 'ec_var';
  var EXPIRY_KEY = 'ec_vid_exp';
  var TTL_DAYS = 90;

  // ── 1. Read from URL params ──────────────────────────
  var params = new URLSearchParams(window.location.search);
  var urlVid = params.get('ec_vid');
  var urlVar = params.get('ec_var');

  if (urlVid) {
    // Fresh visit from landing page — save to localStorage
    try {
      localStorage.setItem(STORAGE_KEY, urlVid);
      localStorage.setItem(EXPIRY_KEY, String(Date.now() + TTL_DAYS * 86400000));
      if (urlVar) localStorage.setItem(VARIANT_KEY, urlVar);
    } catch (e) {
      // localStorage unavailable (private browsing etc.) — continue anyway
    }

    // Clean URL (remove ec_vid/ec_var params without reload)
    params.delete('ec_vid');
    params.delete('ec_var');
    var cleanUrl =
      window.location.pathname +
      (params.toString() ? '?' + params.toString() : '') +
      window.location.hash;
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', cleanUrl);
    }
  }

  // ── 2. Read from localStorage ────────────────────────
  var vid, variant;
  try {
    vid = localStorage.getItem(STORAGE_KEY);
    variant = localStorage.getItem(VARIANT_KEY);
    var expiry = parseInt(localStorage.getItem(EXPIRY_KEY) || '0', 10);
    // Clear if expired
    if (expiry && Date.now() > expiry) {
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(VARIANT_KEY);
      localStorage.removeItem(EXPIRY_KEY);
      vid = null;
      variant = null;
    }
  } catch (e) {
    vid = urlVid;
    variant = urlVar;
  }

  // No visitor ID — nothing to do
  if (!vid) return;

  // ── 3. Intercept checkout form creation ──
  // Bundle builders do clearCart() → addItems() → submitBuyNowForm()
  // which creates a <form action="/checkout"> and submits immediately.
  // Cart attributes are wiped by clearCart() and can't be re-set in time.
  // This observer catches the form and injects hidden attribute fields.
  function injectFormFields(form) {
    if (form.querySelector('input[name="attributes[ec_vid]"]')) return;
    var f1 = document.createElement('input');
    f1.type = 'hidden';
    f1.name = 'attributes[ec_vid]';
    f1.value = vid;
    form.appendChild(f1);
    if (variant) {
      var f2 = document.createElement('input');
      f2.type = 'hidden';
      f2.name = 'attributes[ec_var]';
      f2.value = variant;
      form.appendChild(f2);
    }
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.tagName === 'FORM' && node.action && node.action.includes('/checkout')) {
          injectFormFields(node);
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // ── 5. Intercept form.submit() ───────────
  // Final safety net — catches any checkout form submission even if
  // the MutationObserver missed it (e.g. form created + submitted sync).
  var origSubmit = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function () {
    if (this.action && this.action.includes('/checkout')) {
      injectFormFields(this);
    }
    return origSubmit.apply(this, arguments);
  };
})();
